import request from '../../utils/requests'

/**
 * Tag: OrgSourceConfig
 */

const baseUrl ="/api/OrgSourceConfig";



/**
 * 新增或编辑
 * @param {*} body
 * {
 *    OrgSourceConfigId Desc:主键ID Required:false
 *    ParentId Desc:父级id Required:false
 *    SourceDesc Desc:来源描述 Required:true
 * }
 */
async function _addOrUpdate(body) {
  return request(baseUrl+'/addOrUpdate',{
    method: 'POST',
    body: body,
  });

}



/**
 * 删除
 * @param {*} param
 * {
 *    id Desc: Required:true
 * }
 */
async function _delete(param) {
  return request(baseUrl+'/delete',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取机构配置Model
 * @param {*} param
 * {
 *    id Desc: Required:true
 * }
 */
async function _getModel(param) {
  return request(baseUrl+'/getModel',{
    method: 'POST',
    params: param,
  });

}



/**
 * GetList
 */
async function _getList() {
  return request(baseUrl+'/getList',{
    method: 'GET',
  });

}


/**
 * 更新上下架状态
 * @param {*} param
 * {
 *    id Desc: Required:true
 * }
 */
async function _updateIsOnline(param) {
  return request(baseUrl+'/UpdateIsOnline',{
    method: 'GET',
    params: param,
  });

}



export default{
  _addOrUpdate,
  _delete,
  _getModel,
  _getList,
  _updateIsOnline
}




// WEBPACK FOOTER //
// ./src/services/orgSourceConfig.js